'use client'

import type { FC } from 'react'
import type { TooltipProps } from './types'
import { TooltipProvider } from './TooltipProvider'
import { TooltipTrigger } from './TooltipTrigger'
import { TooltipContent } from './TooltipContent'
import clsx from 'clsx'
import { Typography } from '../Typography'

export const Tooltip: FC<TooltipProps> = ({
  title,
  supportingText,
  customContent,
  subtle = true,
  condensed,
  children,
  rootNodeId,
  rootElement,
  contentWrapperClassName,
  triggerClassName,
  stopPropagationOnClick,
  ...options
}) => (
  <TooltipProvider {...options}>
    <TooltipTrigger className={triggerClassName}>{children}</TooltipTrigger>
    <TooltipContent rootNodeId={rootNodeId} rootElement={rootElement}>
      <div
        className={clsx(
          contentWrapperClassName,
          'max-w-80 space-y-3 rounded-lg border shadow-md antialiased',
          {
            'p-3': !condensed,
            'p-2': condensed,
            'border-subtle bg-high ': subtle,
            'border-forest-1000 bg-contrast': !subtle,
          },
        )}
        onClick={(e) => {
          stopPropagationOnClick && e.stopPropagation()
        }}
      >
        {(title || supportingText) && (
          <div className="space-y-0.5">
            {title && (
              <Typography
                className={clsx({
                  'text-default-on-dark': !subtle,
                  'text-default': subtle,
                })}
                size="xs"
                weight="semibold"
              >
                {title}
              </Typography>
            )}
            {supportingText && (
              <Typography
                className={clsx({
                  'text-default-on-dark': !subtle && !title,
                  'text-default': subtle && !title,
                  'text-subtle-on-dark': !subtle && title,
                  'text-subtle': subtle && title,
                })}
                size="xs"
              >
                {supportingText}
              </Typography>
            )}
          </div>
        )}
        {customContent && customContent}
      </div>
    </TooltipContent>
  </TooltipProvider>
)
